const formatTemperature = (tempC) => {
  let temp = window.celsiusToUserTemp(tempC);
  return temp + '&deg;' + window.currentUser.temp_pref;
}

export default formatTemperature;
